/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:53:54 
 * @Last Modified by:   syyoon@yongtrim.com 
 * @Last Modified time: 2018-07-09 17:53:54 
 */


import { Injectable } from '@angular/core';
import { LoadingController, Loading } from 'ionic-angular';

@Injectable()
export class LoadingService {
  private loading: Loading;

  constructor(private loadingController: LoadingController) {
  }

  public showLoading(isLoading, message?: string) {
    if (isLoading) {
      if (this.loading)
        return;

      this.loading = this.loadingController.create({
        spinner: 'circles'
      });
      this.loading.present();
    } else {

      if (this.loading)
        this.loading.dismiss();
      this.loading = null;
    }
  }

  public isLoading() {
    return !!this.loading;
  }
}



// WEBPACK FOOTER //
// ./src/services/loading.service.ts